import React from "react";

import CricketPlayerDetailHead from "../../cricket/CricketPlayerDetailHead";
import CricketPlayerInfo from "../../cricket/CricketPlayerInfo";
import CricketPlayerStats from "../../cricket/CricketPlayerStats";
import CricketPlayerMatches from "../../cricket/CricketPlayerMatches";

const CricketPlayerWidgetWrap = ({
  dataId,
  dataType,
  sport,
  data,
  headData,
  loadCSS,
  dataClient = false,
  websiteBaseUrl,
  dataPath,
  dataTitle,
  head,
}) => {
  const commonProps = {
    ServerData: data,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath,
    sport,
    title: dataTitle,
  };

  const headProps = {
    ServerData: headData,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath,
    sport,
  };

  const showHead = head === "player";

  // Player Detail Head (header with photo, name, stats)
  if (dataType === "cricket-player-head") {
    return <CricketPlayerDetailHead {...commonProps} />;
  }

  // Player Info (overview, birthplace, education, teams)
  if (dataType === "cricket-player-info") {
    return (
      <>
        {showHead && <CricketPlayerDetailHead {...headProps} />}
        <CricketPlayerInfo {...commonProps} />
      </>
    );
  }

  // Player Stats (batting/bowling statistics with format filters)
  if (dataType === "cricket-player-stats") {
    return (
      <>
        {showHead && <CricketPlayerDetailHead {...headProps} />}
        <CricketPlayerStats {...commonProps} />
      </>
    );
  }

  // Player Matches (recent matches with format filter)
  if (dataType === "cricket-player-matches") {
    return (
      <>
        {showHead && <CricketPlayerDetailHead {...headProps} />}
        <CricketPlayerMatches {...commonProps} />
      </>
    );
  }

  return <h1>Cricket Player Widget Not Found!</h1>;
};

export default CricketPlayerWidgetWrap;
